<template>
    <div>
        <FullPageLoader :isLoading="fullpageLoading"/>

        <div class="row">
            <div class="column small-6 medium-8">
                <PageTitle
                    :title="$route.params.type == 'ingepland' ? 'Ingeplande facturen' : $route.params.type == 'los' ? 'Losse facturen' : $route.params.type == 'geescaleerd' ? (escalationName == 'escalatie' ? 'Geëscaleerde dossiers' : 'Deurwaarders dossiers') : 'Verzonden facturen'"
                    :total="total"
                    :loading="loading"
                    :description="pageDescription"
                />
            </div>
            <div class="column small-6 medium-4 text-right">
                <!-- <b-button type="is-dark" tag="router-link" :to="{ name: 'InvoicesRecord', params: {id: 'nieuw'} }">Contract aanmaken</b-button> -->
                <b-button type="is-dark" tag="router-link" v-if="type == 'los'" :to="{ name: 'CreateInvoiceRecord', query: {type: 'los'} }" class="marginbottom10">Nieuw</b-button>
                <b-field class="cancelledswitch" v-show="type == 'recent' || type == 'los'">
                    <span class="label">Toon betaalde facturen</span><b-switch :disabled="loading" v-model="showPaidOrders" type="is-success"></b-switch>
                </b-field>

                <!-- <b-field class="cancelledswitch" v-show="type != 'los' && type != 'geescaleerd'">
                    <span class="label">Toon geannuleerde facturen</span><b-switch :disabled="loading" v-model="showCancelledOrders" type="is-success"></b-switch>
                </b-field> -->
            </div>
        </div>

        <div class="row" v-if="filters && Object.keys(filters).length">
            <div class="column">
                <h5>Filters</h5>

                <b-field>
                    <b-tag v-if="filters.action && filters.action == 1"
                        type="is-primary"
                        close-type='is-danger'
                        attached
                        closable
                        aria-close-label="Filter verwijderen"
                        @close="removeFilter('action')"
                    >
                        Facturen waar actie vereist is
                    </b-tag>
                </b-field>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-field label="Zoek een factuur">
                    <b-autocomplete
                        :data="invoicesFound"
                        field="number"
                        placeholder="Zoeken op factuur nummer"
                        :loading="isFetching"
                        @typing="findInvoice"
                        @select="option => selectedInvoice = option">
                        <template v-slot="props">
                            <span v-if="user && user.role == 'pit' && dataBelongsTo == 'all'">{{ organisations[props.option.organisation] ? organisations[props.option.organisation].name : '' }}&nbsp;-&nbsp;</span>{{ props.option.number }}&nbsp;-&nbsp;{{ moment(props.option.invoice_date).format('DD-MM-Y') }} - <strong>{{ props.option.customer.firstname }}&nbsp;{{ props.option.customer.lastname }}</strong> - {{ props.option.customer.email }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                    class="table-with-dropdown"
                    :narrowed="windowWidth < 1200"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="organisation_location" width="300" label="Vestiging" :visible="user && user.organisation_locations && user.organisation_locations.length > 1" sortable>
                            <span v-if="props.row.organisation_location">
                                <span v-if="props.row.organisation_location.name + (props.row.organisation_location.city ? ` - ${props.row.organisation_location.city}` : '').length >= 27">
                                    <b-tooltip :label="(props.row.organisation_location.name + ' (' + props.row.organisation_location.city+')')" position="is-right">
                                        {{ props.row.organisation_location.name + (props.row.organisation_location.city ? ` - ${props.row.organisation_location.city}` : '')|truncate(25, '..') }}
                                    </b-tooltip>
                                </span>
                                <span v-else>{{ props.row.organisation_location.name + (props.row.organisation_location.city ? ` - ${props.row.organisation_location.city}` : '') }}</span>
                            </span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="number" :label="type == 'geescaleerd' ? 'Dossier nr.' : 'Factuur nr.'" width="120">
                            <router-link :to="{ name: 'InvoicesRecord', params: {id: props.row.id} }">
                                <b-tooltip v-if="props.row.number.length > 9" :label="props.row.number" position="is-right">
                                    <strong>{{ truncateStart(props.row.number, 6, '..') }}</strong>
                                </b-tooltip>
                                <span v-else>
                                    <strong>{{ props.row.number|truncate(10, '..') }}</strong>
                                </span>
                            </router-link>
                        </b-table-column>

                        <b-table-column v-slot="props" field="boxes" label="Box nr." width="120" v-if="user.organisation_type && user.organisation_type == 'box' && type != 'los'">
                            <span v-for="(box, index) in _.uniqBy(props.row.boxes, (box) => box.box.id )" :key="box.id">
                                <b-button tag="router-link" :to="{ name: 'BoxesRecord', params: {id: box.box.id} }" type="is-light" size="is-small" v-if="index < 2">
                                    {{ box.box.number|truncate(10, '..') }}
                                </b-button>
                                <b-tooltip v-if="index >= 2" :label="props.row.boxes.slice(2).map(box => box.box.number).join(', ')">
                                    <b-button type="is-light" size="is-small">+{{ props.row.boxes.length - 2 }}</b-button>
                                </b-tooltip>
                            </span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="customer" label="Klant" sortable>
                            <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }" v-if="props.row.customer">
                                <span v-if="hideSensitiveData">********</span>
                                <span v-else>
                                    {{ (props.row.customer.firstname + ' ' + props.row.customer.lastname).length > 18 ? truncate(props.row.customer.firstname+' '+props.row.customer.lastname, 20, '..') : props.row.customer.firstname + ' ' + props.row.customer.lastname }}
                                    <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                        <br>
                                        <strong>
                                            <span v-if="props.row.customer.companyname.length >= 20">
                                                <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                                    {{ props.row.customer.companyname|truncate(18, '..') }}
                                                </b-tooltip>
                                            </span>
                                            <span v-else>{{ props.row.customer.companyname }}</span>
                                        </strong>
                                    </span>
                                </span>
                            </b-button>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="customer.type" label="Type" v-if="type !== 'geescaleerd'" sortable>
                            <span v-if="hideSensitiveData">********</span>
                            <span v-else>{{ props.row.customer.type == 'normal' ? 'Particulier' : props.row.customer.type == 'business' ? 'Zakelijk' : props.row.customer.type == 'foundation' ? 'Stichting' : props.row.customer.type }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="status" label="Status" width="100">
                            <!-- <b-tag :type="_.isNull(props.row.status) ? 'is-dark' : props.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], props.row.status) ? 'is-danger' : _.includes(['one_fail'], props.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], props.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(props.row.status) }}</b-tag> -->
                            <InvoiceStatus
                                :id="props.row.id"
                                :status="props.row.status"
                                :send_at="props.row.send_at"
                                :payments="props.row.invoice_payments"
                                :type="type"
                                :contract="props.row.contract"
                                @reload="loadAsyncData()"
                            />
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="type == 'geescaleerd'" field="escalated_at" label="Afgerond" width="100">
                            <span v-if="props.row.invoices">
                                <b-tag :type="props.row.invoices.filter(invoice => invoice.status === 'escalated_done' || invoice.status === 'paid').length === 0 ? 'is-danger' : props.row.invoices.filter(invoice => invoice.status === 'escalated_done' || invoice.status === 'paid').length === props.row.invoices.length ? 'is-success' : 'is-warning'">
                                    {{ props.row.invoices.filter(invoice => invoice.status === 'escalated_done' || invoice.status === 'paid').length }} / {{ props.row.invoices.length }}
                                </b-tag>
                            </span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="total_price" label="Totaal" width="120" numeric>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.total">€&nbsp;{{ props.row.total }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="type == 'recent'" label="Factuurdatum" width="120" sortable>
                            <span>{{ props.row.invoice_date|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="type != 'geescaleerd' && windowWidth > 1675" :field="type == 'recent' ? 'send_at' : 'invoice_date'" :label="type == 'recent' ? 'Verstuurd' : 'Datum'" width="180" sortable>
                            <span v-if="type == 'recent'">{{ props.row.send_at|humanDate }}</span>
                            <span v-else>{{ props.row.invoice_date|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="type == 'los'" label="Verzonden" width="120" sortable>
                            <span v-if="_.isNull(props.row.send_at)">Nee</span>
                            <span v-else>{{ props.row.send_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="type === 'geescaleerd'" field="created_at" label="Escalatie" width="120" sortable>
                            {{ props.row.created_at|humanDate }}
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="75">
                            <InvoiceOptionsDropdown
                                :showDropdown="type !== 'geescaleerd'"
                                :type="type"
                                :record="props.row"
                                @reloadInvoices="loadAsyncData"
                            />
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen {{ type == 'geescaleerd' ? 'escalaties' : 'facturen' }} gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>


    </div>
</template>

<script>
import InvoiceOptionsDropdown from '@/vue/invoices/components/InvoiceOptionsDropdown'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'InvoicesOverview',

    components: {
        InvoiceOptionsDropdown
    },

    mixins: [filtersMixin, paramsMixin],

    data () {
        return {
            name: 'InvoicesOverview',
            type: this.$route.params.type,
            records: [],

            total: null,
            loading: false,
            fullpageLoading: false,
            sortField: this.$route.params.type == 'ingepland' ? 'invoice_date' : this.$route.params.type == 'geescaleerd' ? 'created_at' : 'send_at',
            sortOrder: this.$route.params.type == 'ingepland' ? 'asc' : 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: _.has(this.$store.state.searchQueries, ['InvoicesOverview-'+this.type]) ? this.$store.state.searchQueries['InvoicesOverview-'+this.type] : null,
            showCancelledOrders: this.$store.state.showCancelledOrders,
            showPaidOrders: this.$store.state.showPaidOrders,

            invoicesFound: [],
            selectedInvoice: null,
            isFetching: false,
            windowWidth: window.innerWidth,
            filters: {},
        }
    },

    computed: {
        paginated() {
            return this.records && this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        // Moved to excelExport mixin!!
        // exporting(){
        //     return this.$store.state.exporting
        // },
        // Moved to excelExport mixin!!
        // paid(){
        //     return this.$store.state.onlyPaidInvoices
        // },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        escalationName() {
            return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        },
        pageDescription() {
            if (this.type == 'ingepland') {
                return 'Deze facturen worden verzonden na een incasso opdracht of bij het bereiken van de betaaldatum voor handmatige facturen.'
            }
            if (this.type == 'los') {
                return 'Dit zijn losse facturen, aangemaakt zonder contract.'
            }
            if (this.type == 'geescaleerd') {
                return 'Deze dossiers (samenstelling van facturen) zijn geëscaleerd en mogelijk naar de deurwaarder verzonden.'
            }
            if (this.type == 'recent') {
                return 'Deze facturen zijn actueel en verzonden naar de klant.'
            }

            return false
        }
    },

    created(){
        if(_.has(this.$route.query, 'action') && this.$route.query.action == 1){
            this.filters.action = this.$route.query.action
        } else {
            if (this.filters.action) {
                delete this.filters.action
            }
        }

        // Check if in this session a query is saved (last success) else use default sorting.
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
        })
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            let params = this.setParams(this.searchParams, `InvoicesOverview-${this.type}`)

            if (Object.keys(this.filters).length) {
                params += `&${Object.keys(this.filters).join('&')}`
            }

            this.loading = true

            axios.get(`/api/invoices?type=${this.type}&${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: `InvoicesOverview-${this.type}`, query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching invoices:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        truncate(string, value, ending = '..') {
            return string.substring(0, value) + ending
        },

        truncateStart(string, value, ending = '..') {
            return ending + string.substring(string.length - value)
        },

        // Moved to excelExport mixin!!
        // export(){
        //     let params = []
        //     this.fullpageLoading = true

        //     if(_.has(this.$route.meta, 'dateRangeFilter') && !_.isNull(this.$store.state.dateRange)){
        //         params.push(`fromDate=${moment(this.$store.state.dateRange[0]).format('YYYY-MM-DD')}`)
        //         params.push(`toDate=${moment(this.$store.state.dateRange[1]).format('YYYY-MM-DD')}`)
        //     }
        //     params.push(`type=${this.type}`)
        //     params.push(`paid=${this.paid}`)

        //     if(this.user.role == 'admin'){
        //         params.push(`organisation=${this.$store.state.dataBelongsTo}`)
        //     }

        //     params = params.join('&')

        //     axios.get(`/api/invoices/export?${params}`, {
        //         headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
        //     }).then((response) => {
        //         window.open('/export/'+response.data.token, '_blank')
        //     }).catch((e) => {
        //         console.error(e)
        //     }).then(() => {
        //         this.fullpageLoading = false
        //         this.$store.commit('startExport', false)
        //     })
        // },

        findInvoice: _.debounce(function (term) {
            if (!term.length) {
                this.data = []
                return
            }
            this.isFetching = true

            let searchParm = `search=${term}`
            if (this.user?.role === 'pit') {
                searchParm += `&organisation=${this.dataBelongsTo}`
            }

            axios.get(`/api/invoices/find?${searchParm}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.invoicesFound = response.data.data
            }).catch((error) => {
                console.error('[❌] Error while searching invoices:', error)
            }).then(() => {
                this.isFetching = false
            })
        }, 250),

        removeFilter(filter){
            delete this.filters[filter]

            this.setParams(Object.keys(this.filters).length ? this.filters : this.searchParams, 'InvoicesOverview')
            this.$router.push({ query: this.filters })

            this.loadAsyncData()
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    },

    watch: {
        // Moved to excelExport mixin!!
        // exporting(newVal){
        //     if(!!newVal){
        //         this.export()
        //     }
        // },

        showCancelledOrders(val) {
            this.$store.dispatch('setShowCancelledOrders', val)
            this.loadAsyncData()
        },

        showPaidOrders(val) {
            this.$store.dispatch('setShowPaidOrders', val)
            this.loadAsyncData()
        },

        // Go to selected box
        selectedInvoice(newVal){
            if(!_.isNull(newVal)){
                this.$router.push({'name': 'InvoicesRecord', params: {id: newVal.id}})
            }
        },

        '$route.query.action' (newVal, oldVal) {
            if (newVal === 1 && !oldVal) {
                this.filters.action = 1
            } else {
                delete this.filters.action
            }

            this.loadAsyncData()
            this.$store.dispatch('fetchInvoicesNeedsAction')
        }
    }
}
</script>
